module.exports = __webpack_public_path__ + "bg_alaska_first.612bb54.jpg";